import Text from "./Text"
import { useNavigate } from "react-router-dom"
import SadPapelin from "./icons/SadPapelin";
import { useTheme } from "../scripts/functions/ThemeProvider";
const RedirectionPage = ({error, page}) => {

    const {theme} = useTheme();     
    const navigate = useNavigate();

    const redirect = () => {
        if (page) {
            navigate(page);
        } else {
            navigate(-1);
        }
    }

    const getErrorMessage = (errorCode) => {
        switch(errorCode) {
            case 403:
                return {
                    mainMsg: "Acceso no autorizado",
                    bottomMsg: "No cuentas con los permisos necesarios para realizar esta acción, si crees que es un error, contacta a tu administrador"
                }
            case 404:
                return {
                    mainMsg: "Página no encontrada",
                    bottomMsg: "Lo sentimos, no pudimos encontrar la página que estás buscando."
                }
            default:
                return {
                    mainMsg: "Ocurrió un error",
                    bottomMsg: "Lo sentimos, ocurrió un error inesperado. Por favor, regresa a la página principal."
                }
        }
    }

    const messages = getErrorMessage(error);

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'start', width: '100%', height: '100vh', gap:'32px', marginTop: '10vh'}}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Text color={theme.ONED} size={22} weight={"extrabold"}>Error {error}</Text>
                <Text color={theme.ONED} size={22}>{messages.mainMsg}</Text>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <SadPapelin/>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap:'16px'}}>
                <Text color={theme.ONED} size={17}>{messages.bottomMsg}</Text>
                <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Magenta} onClick={() => redirect()} size={15}>Regresar</Text>
            </div>
        </div>
    )
}

export default RedirectionPage;